import { applyCap } from "../score-caps";
import AverageScoreLightBox from "./average-score-light-box";
import { findAverageWPSScore, totalScore } from "../average-wps-scores";
import { FormattedScore } from "./formatted-currency";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function LeaderboardDistanceStats({ payouts, ticket, tickets, tournament }) {
  if (tournament.get("tournament_type") === "Survivor") {
    return null;
  }
  var betType = tournament.get("bet_type");

  var table;
  var lightBoxLinkText = "View Average Scores";
  if (ticket.get("rank") > 1) {
    table = <DistanceTable betType={betType} payouts={payouts} ticket={ticket} tickets={tickets} />;
    lightBoxLinkText = "View More Average Scores";
  }
  return (
    <div className="padding--is-5 text-center">
      {table}

      <AverageScoreLightBox betType={betType} text={lightBoxLinkText} />
    </div>
  );
});

function DistanceTable({ betType, payouts, ticket, tickets }) {
  var leaderTicket = tickets.get(0);
  var inTheMoneyPlace = Object.keys(payouts).map(place => parseInt(place)).reduce((a, b) => Math.max(a, b));
  var moneyDistance;
  if (inTheMoneyPlace < ticket.get("rank")) {
    var inTheMoneyTicket = tickets.findLast(t => t.get("rank") <= inTheMoneyPlace);
    moneyDistance = <DistanceFromEntrantRow betType={betType} name="Money" targetTicket={inTheMoneyTicket} ticket={ticket} />;
  }

  var winHeader;
  if (betType.indexOf("W") !== -1) {
    winHeader = (
      <th className="text-center">
        W
      </th>
    );
  }
  var placeHeader;
  if (betType.indexOf("P") !== -1) {
    placeHeader = (
      <th className="text-center">
        P
      </th>
    );
  }
  var showHeader;
  if (betType.indexOf("S") !== -1) {
    showHeader = (
      <th className="text-center">
        S
      </th>
    );
  }

  return (
    <table className="table--border--width-1 table-layout--is-auto table--padding-is-small border-radius--is-3 text-tiny text-center line-height--is-1 margin-bottom--is-0">
      <thead>
        <tr>
          <th className="text-center text-right">
            Current Distance
          </th>

          <th className="text-right">
            Odds Needed
          </th>

          <th className="text-left padding-left--is-5">
            Avg. Score
          </th>

          {winHeader}

          {placeHeader}

          {showHeader}
        </tr>
      </thead>

      <tbody>
        <DistanceFromEntrantRow betType={betType} name="Lead" targetTicket={leaderTicket} ticket={ticket} />

        {moneyDistance}
      </tbody>
    </table>
  );
}

function DistanceFromEntrantRow({ betType, name, targetTicket, ticket }) {
  var distance = targetTicket.get("score") - ticket.get("score");

  var averageWPSScore = findAverageWPSScore(distance, betType);
  var total = totalScore(averageWPSScore, betType);

  var scores = betType.split("").map(type => (
    <td className="color--is-medium-gray text-right" key={type}>
      <FormattedScore value={applyCap(averageWPSScore[type], type)} />
    </td>
  ));

  return (
    <tr>
      <td className="text-right">
        <span className="color--is-medium-gray text--is-italic">
          {name}
          :

          {" "}
        </span>

        <span className="text--is-bold text-small">
          <FormattedScore value={distance} />
        </span>
      </td>

      <td className="text-right">
        <span className="text--is-bold text-small">
          {averageWPSScore.odds}
        </span>
      </td>

      <td className="text--is-normal text-left padding-left--is-5">
        <FormattedScore value={total} />
      </td>

      {scores}
    </tr>
  );
}
